
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitoaurangabadcabservice() {



    const cardData =
    {
        keyword: 'Mumbai to Aurangabad Cab Service',
        heading: 'Skyline Cabs: Mumbai to Aurangabad Cab Service',
        headingDescription: 'Skyline Cabs offers comfortable and reliable Mumbai to Aurangabad Cab Service for a seamless journey to one of Maharashtra as most historic cities. Whether you are planning a spiritual visit to the Ellora and Ajanta Caves, exploring the Bibi Ka Maqbara, or enjoying the local cuisine, our well-maintained vehicles and professional drivers ensure a smooth and enjoyable ride.​',

        top: 'Top Places to Visit in Aurangabad with Skyline Cabs',

"topPlaces": [
    {
        "title": "Ajanta Caves",
        "description": "A UNESCO World Heritage site, the Ajanta Caves are a group of 30 rock-cut Buddhist monasteries and temples, featuring exquisite murals and sculptures that date back to the 2nd century BCE. They are renowned for their intricate paintings depicting the life of the Buddha."
    },
    {
        "title": "Ellora Caves",
        "description": "Another UNESCO World Heritage site, the Ellora Caves are a complex of 34 monasteries and temples, carved into cliffs, and date back to between the 5th and 10th centuries. These caves showcase Hindu, Buddhist, and Jain rock-cut architecture."
    },
    {
        "title": "Bibi Ka Maqbara",
        "description": "Often referred to as the 'Taj of the Deccan,' Bibi Ka Maqbara is a beautiful mausoleum built in the 17th century by Aurangzeb’s son, Azam Shah, in memory of his mother. Its architecture closely resembles the Taj Mahal."
    },
    {
        "title": "Aurangabad Caves",
        "description": "A group of 12 rock-cut Buddhist caves located on a hill, these caves are believed to have been carved between the 6th and 7th centuries. They feature some remarkable sculptures and offer a glimpse into ancient Buddhist life."
    },
    {
        "title": "Daulatabad Fort",
        "description": "One of the best-preserved forts in Maharashtra, Daulatabad Fort stands atop a hill and offers panoramic views of the surrounding region. The fort is known for its massive walls, intricate gates, and an elaborate defense system."
    },
    {
        "title": "Grishneshwar Temple",
        "description": "An important pilgrimage site, Grishneshwar Temple is dedicated to Lord Shiva and is one of the 12 Jyotirlingas in India. It is located near Ellora Caves and holds immense religious significance."
    },
    {
        "title": "Panchakki",
        "description": "An ancient water mill built in the 17th century, Panchakki was used to grind grains for the local community. The site also features a beautiful garden and is a great place to learn about the engineering marvels of the era."
    },
    {
        "title": "Jama Masjid",
        "description": "Built in the 17th century, Jama Masjid is one of the oldest mosques in Aurangabad. The mosque is known for its grand architecture, intricate carvings, and historical importance."
    },
    {
        "title": "Nath Siddhanta Garden",
        "description": "A serene garden dedicated to the teachings of Nath yogis, this garden offers a peaceful environment for visitors to relax. It is known for its scenic beauty and spiritual significance."
    },
    {
        "title": "Siddharth Garden and Zoo",
        "description": "A family-friendly destination, Siddharth Garden and Zoo is a popular park in Aurangabad, featuring a variety of animals, birds, and a peaceful green space. It’s ideal for an afternoon stroll and for children to explore."
    }
],

"services": [
    {
      "name": "Mumbai to Aurangabad Cab",
      "description": "Skyline Cabs offers comfortable and reliable taxi services from Mumbai to Aurangabad. Enjoy a smooth and scenic journey with professional drivers."
    },
    {
      "name": "Aurangabad Taxi from Mumbai",
      "description": "Book a taxi from Mumbai to Aurangabad with Skyline Cabs. We ensure timely pickups and a comfortable ride for a seamless travel experience."
    },
    {
      "name": "Mumbai to Aurangabad One Way Taxi",
      "description": "Rent a one-way taxi from Mumbai to Aurangabad with Skyline Cabs. Ideal for travelers seeking a direct and hassle-free journey."
    },
    {
      "name": "Taxi Service Aurangabad from Mumbai",
      "description": "Skyline Cabs provides reliable taxi services from Mumbai to Aurangabad. Travel comfortably with our experienced drivers, ensuring a stress-free trip."
    },
    {
      "name": "Mumbai to Aurangabad Cab Booking",
      "description": "Book your cab from Mumbai to Aurangabad easily with Skyline Cabs. Enjoy flexible booking options and a comfortable ride for your journey."
    }
  ],
  "tableData": [
    ["Mumbai to Aurangabad Cab", "Aurangabad Taxi from Mumbai"],
    ["Mumbai to Aurangabad One Way Taxi", "Taxi Service Aurangabad from Mumbai"],
    ["Mumbai to Aurangabad Cab Booking"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Mumbai to Aurangabad Cab Service",
      "WhyChoosedescription": "Book a reliable and comfortable cab from Mumbai to Aurangabad for a seamless intercity travel experience. Whether for business, heritage tours, or family visits, we ensure a smooth journey."
    },
    {
      "WhyChooseheading": "Comfortable and Long-Distance Ready Cabs",
      "WhyChoosedescription": "Our cabs are designed for long drives, with spacious seating, smooth suspension, and air conditioning to ensure a relaxed and enjoyable ride from Mumbai to Aurangabad."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Rates",
      "WhyChoosedescription": "Get competitive pricing with no hidden charges. Our straightforward fare structure ensures you know exactly what you're paying for."
    },
    {
      "WhyChooseheading": "Experienced and Courteous Drivers",
      "WhyChoosedescription": "Our professional drivers are well-versed with the Mumbai to Aurangabad route, ensuring a safe, timely, and pleasant journey with polite and respectful service."
    },
    {
      "WhyChooseheading": "Perfect for Business, Tourism, and Family Trips",
      "WhyChoosedescription": "Whether you're visiting the Ajanta & Ellora Caves or heading for business meetings, our cab service is ideal for all kinds of travel to Aurangabad."
    },
    {
      "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
      "WhyChoosedescription": "All our cabs are regularly sanitized and maintained to ensure high hygiene standards and mechanical reliability for long-distance travel."
    },
    {
      "WhyChooseheading": "Flexible Travel Options",
      "WhyChoosedescription": "Choose from one-way trips, round trips, or multi-day rental plans tailored to your schedule and travel preferences."
    },
    {
      "WhyChooseheading": "24/7 Booking and Support",
      "WhyChoosedescription": "Book your cab easily online or via phone. Our 24/7 customer support team is always ready to assist with bookings, changes, or special travel requests."
    }
  ]
  
  
  
  
  
  
  
  









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Mumbai to Aurangabad with Skyline Cabs?',
            answer:
                'Booking a cab from Mumbai to Aurangabad with Skyline Cabs is simple. Use our website, mobile app, or call our 24/7 customer support. Provide your pickup location, destination (Aurangabad), travel date, and vehicle preference to confirm the booking.',
        },
        {
            id: 2,
            question: 'What is the distance and travel time from Mumbai to Aurangabad?',
            answer:
                'The distance from Mumbai to Aurangabad is approximately 330 km. Travel time generally ranges between 6.5 to 8 hours depending on traffic and road conditions.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for the Mumbai to Aurangabad trip?',
            answer:
                'We offer a range of vehicles including Swift Dzire, Ertiga, Innova Crysta, Kia Carens, and SUVs. For larger groups or family travel, we also provide Tempo Travellers and luxury vans.',
        },
        {
            id: 4,
            question: 'Are your cab fares fixed from Mumbai to Aurangabad?',
            answer:
                'Yes, our fares are fixed and transparent. The price includes vehicle rental, fuel, driver charges, tolls, and taxes. You’ll know the total amount before confirming your ride—no hidden charges.',
        },
        {
            id: 5,
            question: 'Can I book a one-way cab from Mumbai to Aurangabad?',
            answer:
                'Yes, Skyline Cabs offers both one-way and round-trip cab options from Mumbai to Aurangabad. Choose what works best for your travel needs.',
        },
        {
            id: 6,
            question: 'Is it safe to travel from Mumbai to Aurangabad by cab at night?',
            answer:
                'Yes, it’s safe. Our drivers are experienced in highway travel and trained for night driving. We ensure well-maintained vehicles and 24/7 support for your safety and comfort.',
        },
        {
            id: 7,
            question: 'Can I take breaks during the journey?',
            answer:
                'Yes, you can take short stopovers along the way for food, rest, or sightseeing. Just inform the driver during the journey or mention it at the time of booking.',
        },
        {
            id: 8,
            question: 'What are the payment options for this route?',
            answer:
                'We accept payments via UPI, credit/debit cards, net banking, and cash. Online payments are securely processed through reliable gateways.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my Mumbai to Aurangabad booking?',
            answer:
                'Yes, Skyline Cabs provides flexible cancellation and rescheduling options. You can manage your booking through our app, website, or by calling our customer support.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for the Mumbai to Aurangabad trip?',
            answer:
                'Skyline Cabs offers reliable, comfortable, and safe cab services. With professional drivers, clean vehicles, fixed pricing, and strong customer support, your journey from Mumbai to Aurangabad will be smooth and stress-free.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ashok More",
            rating: 5,
            review: "Excellent service! Took a cab from Mumbai to Aurangabad with Skyline. The driver was polite and knew the best routes. The car was clean and very comfortable for the long drive."
        },
        {
            name: "Ms. Jyoti Kale",
            rating: 4,
            review: "My trip from Mumbai to Aurangabad was smooth and safe. Just wish the car had more charging points. Otherwise, great driver and very professional service."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Aurangabad Cab",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-aurangabad-cab.jpg",
  "description": "Book Mumbai to Aurangabad cab with Skyline Cabs for a smooth, comfortable, and affordable journey. Choose from AC sedans, SUVs, or luxury vehicles — available 24/7 with professional drivers and fixed pricing.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8721"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4499",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-aurangabad-cab"
  }
};



      
     

    return (
        <div>

<Helmet>
  <title>Mumbai to Aurangabad Cab | Fixed Fare Taxi Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Aurangabad cab with Skyline Cabs for a smooth, comfortable, and affordable journey. Choose from AC sedans, SUVs, or luxury vehicles — available 24/7 with professional drivers and fixed pricing." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Aurangabad Cab, One Way Cab Mumbai to Aurangabad, SUV Taxi Mumbai to Aurangabad, AC Sedan Cab Mumbai Aurangabad, Mumbai to Aurangabad Outstation Cabs, Luxury Cab Hire Mumbai to Aurangabad, Skyline Cabs Booking, 24/7 Taxi Service Mumbai Aurangabad, Fixed Fare Cabs" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/102.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitoaurangabadcabservice;